<template>
  <div class="centerArea_wrapper">
    <div class="room-message-wrapper">
      <Skyway type="sfu" />
      <RoomMessageColumn :room-name="room.name" v-if="room.display_chat" />
    </div>
    <div class="videoTitle_wrapper wrapper hard">
      <div class="videoTitle_inner flex_center">
        <div class="flex_center">
          <div class="extBtn_wrapper">
            <router-link :to="{name: 'Hall', params: {hallSlug: $route.params.hallSlug}}" class="ext_btn flex_center inner light btn">
              <fa-icon icon="sign-out-alt" />
              <span>退出する</span>
            </router-link>
          </div>
          <h2 class="videoTitle inner light">
            <span>{{ room.name }}</span>
          </h2>
        </div>
        <div class="videoinfoItem_wrapper flex_center">
          <PersonsCount
            v-if="room.max_join_count"
            :hall-slug="hallSlug"
            :room-slug="roomSlug"
            :gte-max-join-count="gteMaxJoinCount($route.params.hallSlug, room.slug, room.max_join_count)"
            :max-join-count="room.max_join_count"
          />
        </div>
      </div>
      <div class="videoTxt_wrapper wrapper background" v-if="!_.isEmpty(room.description)">
        <p>
          <RawHtml :text="room.description" />
        </p>
      </div>
      <div class="videoTxt_wrapper wrapper background">
        <p>
          ビデオ会議は処理負荷が高い機能のため、お使いのデバイス（PC、スマートフォン、タブレット等）の性能によって品質が左右されます。対応ブラウザなどは注意事項をご覧ください。
        </p>
      </div>
      <Participants :participants="$store.getters['participants/getByHallAndRoomSlug']($route.params.hallSlug, room.slug)" />
    </div>
  </div>
</template>

<script>
import Skyway from "../modules/Skyway"
import PersonsCount from "../elements/PersonsCount"
import Participants from "../elements/Participants"
import RawHtml from "../elements/RawHtml"
import RoomMessageColumn from "../modules/RoomMessageColumn"

export default {
  name: "YRoom",
  components: {Participants, PersonsCount, Skyway, RawHtml, RoomMessageColumn},
  props: {
    hallSlug: {
      type: String,
      required: false,
      default: ""
    },
    roomSlug: {
      type: String,
      required: false,
      default: ""
    }
  },
  computed: {
    room: function() {
      return this.$store.getters["room/getBySlug"](this.roomSlug)
    },
    gteMaxJoinCount: vm => (hallSlug, roomSlug, maxJoinCount) => {
      if (maxJoinCount === null) return false

      return vm.$store.getters["participants/countByHallAndRoomSlug"](hallSlug, roomSlug) >= maxJoinCount
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize)
    this.handleResize()
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize)
  },
  methods: {
    handleResize() {
      if (window.innerWidth <= 992) {
        this.$store.commit("sideMenu/collapseByLeft", false)
        this.$store.commit("sideMenu/collapseByRight", false)
      } else {
        return
      }
    }
  }
}
</script>
